"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridList.default;
  }
});

var _GridList = _interopRequireDefault(require("./GridList"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/GridList/index.js
// module id = 717
// module chunks = 0